import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export default function FAQ({ items, testIdPrefix = "faq", theme = "light" }) {
  const isDark = theme === "dark";
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          value={`item-${i}`}
          className={`faq-item ${isDark ? "" : ""}`}
          data-testid={`${testIdPrefix}-item-${i}`}
        >
          <AccordionTrigger
            className={`py-7 text-left hover:no-underline group ${
              isDark ? "text-paper" : "text-charcoal"
            }`}
          >
            <div className="flex items-start gap-6 pr-4">
              <span
                className="font-display text-sm text-gold pt-1 min-w-[36px]"
                style={{ letterSpacing: "0.1em" }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-lg md:text-xl leading-snug">
                {item.q}
              </span>
            </div>
          </AccordionTrigger>
          <AccordionContent
            className={`pb-8 pl-[60px] pr-4 text-[15px] leading-relaxed ${
              isDark ? "text-warm/80" : "text-charcoal/80"
            }`}
          >
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
